/**
 * A field with its label, its help text and whatever is wrong with it.
 *
 * A field whose condition is not met is greyed where it stands rather than
 * removed. A form that adds and removes rows as you answer moves everything
 * below the thing you are reading; leaving the space costs nothing and the
 * greyed row also explains itself - you can see the question exists and what
 * would bring it back.
 */
import type { CompiledField } from "@dp/shared";
import { Control } from "./Control.tsx";

export function Field({
  field, value, visible, readOnly, problems, onChange,
}: {
  field: CompiledField;
  value: unknown;
  visible: boolean;
  readOnly: boolean;
  problems: string[];
  onChange: (value: unknown) => void;
}) {
  const disabled = !visible || readOnly || field.readOnly;
  const wrong = visible && problems.length > 0;

  return (
    <div className={`field${visible ? "" : " is-not-asked"}`}>
      <label htmlFor={field.key}>
        {field.label}
        {field.required && visible && <span className="required-mark" title="Required">*</span>}
      </label>

      <Control field={field} value={value} disabled={disabled} wrong={wrong} onChange={onChange} />

      {!visible && <span className="hint">Not asked, given the answers so far.</span>}
      {visible && field.helpText && <span className="hint">{field.helpText}</span>}
      {wrong && problems.map((problem) => <span className="problem" key={problem}>{problem}</span>)}
    </div>
  );
}
